import Textbase from "@/inside/models/Textbase/Textbase";

/**
 * @property {Readonly<Textbase>|null} textbase
 * @property {string} map.actions
 * @property {string} map.assessments
 * @property {string} map.assignments
 * @property {string} map.icpe
 * @property {string} map.permissions
 * @property {string} map.quiz
 */
export default class Permission {
    constructor() {
        this.textbase = null;
        this.map = {
            actions: Permission.accessNone,
            assessments: Permission.accessNone,
            assignments: Permission.accessNone,
            icpe: Permission.accessNone,
            permissions: Permission.accessNone,
            quiz: Permission.accessNone
        };
    }
    /**
     * @return {Boolean}
     */
     get hasAny(){
        for(let i in this.map){
            if(this.map[i] !== Permission.accessNone){
                return true;
            }
        }
        return false;
    }
    /**
     * @return {string}
     */
    static get accessNone() {
        return "-";
    }

    /**
     * @return {string}
     */
    static get accessRead() {
        return "r";
    }

    /**
     * @return {string}
     */
    static get accessReadWrite() {
        return "rw";
    }

    /**
     * Returns a new instance of `Permission` hydrated with data from given `api_resource`.
     *
     * @param {object} api_resource
     * @return {Permission}
     */
    static fromAPI(api_resource) {
        const out = new Permission();
        return Object.assign(out, {
            textbase: (api_resource.textbase !== null
                ? Object.freeze(Textbase.fromAPI(api_resource.textbase))
                : null
            ),
            map: Object.assign(out.map, api_resource.map)
        });
    }

    /**
     * Returns a new instance of `Permission` hydrated with data from given `string`.
     * This method is compatible with the string returned by `Permission.toString()` method.
     *
     * @param string
     * @return {Permission}
     */
    static fromString(string) {
        let split = string.split("|");
        split = split.fill("-", split.length, 6);

        const out = new Permission();
        Object.assign(out.map, {
            actions: split[0],
            assessments: split[1],
            assignments: split[2],
            icpe: split[3],
            permissions: split[4],
            quiz: split[5]
        });

        return out;
    }

    toString() {
        return [
            this.map.actions,
            this.map.assessments,
            this.map.assignments,
            this.map.icpe,
            this.map.permissions,
            this.map.quiz
        ].join("|");
    }
}
